let scrollbarWidth
export const getScrollbarWidth = () => {
  if (scrollbarWidth != null) {
    return scrollbarWidth
  }
  let outerDiv = document.createElement('div')
  outerDiv.style.width = '100px'
  outerDiv.style.overflowY = 'scroll'
  document.body.appendChild(outerDiv)
  scrollbarWidth = outerDiv.offsetWidth - outerDiv.scrollWidth
  outerDiv.parentNode.removeChild(outerDiv)
  return scrollbarWidth
}
